import { useMutation } from '@tanstack/react-query';

import { postPayDetailStatementPdf, postPayDetailStatementRequest } from '../api';

export const usePostPayDetailPdfDownload = () => {
  const { mutate, data, isSuccess } = useMutation({
    mutationKey: ['postPayDetailPdfDownload'],
    mutationFn: (params) => postPayDetailStatementPdf(params),
  });

  return { mutate, data, isSuccess };
};

export const usePostPayDetailStatementRequest = () => {
  const { mutate, data, isSuccess } = useMutation({
    mutationKey: ['postPayDetailStatementRequest'],
    mutationFn: (params) => postPayDetailStatementRequest(params),
  });

  return { mutate, data, isSuccess };
};
